// The Transfers table's column-visibility toggle: which of its mutable columns default on. Pure, no
// Vue dependency - same shape as `pigsSlaughters/useSlaughtersColumnVisibility.ts`. None of these
// columns are hard-gated - every one stays offered in the dropdown regardless of data, so a reader
// can turn one on ahead of data showing up for it; only the default reads presence. The generic
// mechanics (storage, toggling, select-all) live in the shared `useColumnVisibilityOverrides`
// composable instead.

import type { TransferRow } from '@/types';

/** The columns a reader can show or hide. Fixed columns (date/locations/number/weights) are never in
 * here. */
export type TransferToggleColumnId = 'sow_genetics' | 'boar_genetics' | 'gender' | 'created_by';

/** Left-to-right table order of the mutable columns, matching the wire's own order. */
export const TOGGLE_COLUMN_IDS: readonly TransferToggleColumnId[] = ['sow_genetics', 'boar_genetics', 'gender', 'created_by'];

/** Whether each toggleable column has at least one non-null entry among the given rows. */
export function columnPresence(rows: TransferRow[]): Record<TransferToggleColumnId, boolean> {
    const present = (pick: (row: TransferRow) => unknown) => rows.some((row) => pick(row) !== null);

    return {
        sow_genetics: present((row) => row.sow_genetics),
        boar_genetics: present((row) => row.boar_genetics),
        gender: present((row) => row.gender),
        created_by: present((row) => row.created_by),
    };
}
